export default __webpack_public_path__ + "static/media/arrow_right_wt.bd11f181.svg";